import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 8px;
  margin-top: 8px;
`;
